import React from 'react';
import ShortToggle from '../../../DanitComponents/Toggles/ShortToggle';
import './left-gutter-student-modal-2023.css'
import axios from 'axios';
import { baseUrl } from '../../../assets/Animations';
import { MdCalendarMonth, MdCreditCard, MdHourglassEmpty, MdContentCopy, MdDeleteOutline } from 'react-icons/md';
import { getRequestHeaders } from '../../../api';
import { format, isBefore, parse } from 'date-fns';
import { statusStyles, statusOptions } from '../../studentmodal2023utils';
import { gql, useMutation } from "@apollo/client";

const schoolOptions = [
    {value: 'MMA', name: 'Mountainside', imageUrl: 'https://www.mountainsidemusicacademy.com/logo.png'},
    {value: 'LSMA', name: 'Lakeside', imageUrl: 'https://www.lakesidemusicacademy.com/logo.png'},
    {value: 'TMA', name: 'Treeside', imageUrl: 'https://www.treesidemusicacademy.com/logo.png'},
    {value: 'MOR', name: 'Morningside', imageUrl: 'https://www.morningsidemusicacademy.com/logo.png'},
    {value: 'PSMA', name: 'Parkside', imageUrl: 'https://www.parksidemusicacademy.com/logo.png'},
]

const invoiceInfo = [
    {icon: <MdCalendarMonth size={16} color='#334155' />, label: 'Lessons / Month'},
    {icon: <MdHourglassEmpty size={16} color='#334155' />, label: 'Lessons Received'},
    {icon: <MdCreditCard size={16} color='#334155' />, label: 'Paid'},
]

const LeftGutterStudentModal2023 = ({family, setFamily, deleteFamilyFromState}) => {
    const [invoices, setInvoices] = React.useState([])
    const [lpm, setLpm] = React.useState(0)
    const [totalLessons, setTotalLessons] = React.useState(0)
    const [totalPaid, setTotalPaid] = React.useState(0)
    const [firstLesson, setFirstLesson] = React.useState('')

    let CREATE_CUSTOMER = gql`
    mutation ($input: CustomerCreateInput!) {
      customerCreate(input: $input) {
        didSucceed
        inputErrors {
          code
          message
          path
        }
        customer {
          id
          name
          firstName
          lastName
          email
          address {
            addressLine1
            addressLine2
            city
            province {
              code
              name
            }
            country {
              code
              name
            }
            postalCode
          }
          currency {
            code
          }
        }
      }
    }
  `;
  const [createCustomer] = useMutation(CREATE_CUSTOMER);

    React.useEffect(() => {
        getInvoices()
        findFirstLesson()
    }, [])

    React.useEffect(() => {
        if(invoices.length > 0) {
            calculateLPM()
            calculateTotalLessons()
            calculateTotalPaid()

        }
    }, [invoices])

    const getInvoices = async () => {
        axios.get(`${baseUrl}/invoicesfamid/${family.familyId}`, getRequestHeaders())
        .then(res => setInvoices(res.data))
        .catch(err => console.log(err))
    }

    const calculateLPM = () => {
        let totalLessons = 0;
        let totalStudents = new Set();
      
        invoices.forEach((invoice) => {
          invoice.lessonsToBeBilled.forEach((lesson) => {
            totalLessons += 1;
            totalStudents.add(lesson.studentName);
          });
        });
      
        const numberOfInvoices = invoices.length;
        const numberOfStudents = totalStudents.size;
      
        const average = totalLessons / numberOfStudents / numberOfInvoices;
        //round average to 2 decimal places
        let roundedAverage = Math.round(average * 100) / 100;

        setLpm(roundedAverage);
    }
    const calculateTotalLessons = () => {
        let total = 0
        invoices.forEach(invoice => total = total + invoice.lessonsToBeBilled.length)
        setTotalLessons(total)
    }
    const calculateTotalPaid = () => {
        let total = 0;
        invoices.forEach((invoice) => {
            invoice.lessonsToBeBilled.forEach((lesson) => {
                let length = parseInt(lesson.lessonLength);
    
                if (lesson.studentAllRates) {
                    if (
                        (length === 16 || length === 31 || length === 46 || length === 61) &&
                        lesson.studentAllRates[length - 1] !== undefined
                    ) {
                        total = total + lesson.studentAllRates[length - 1];
                    } else if (lesson.studentAllRates[length] !== undefined) {
                        total = total + lesson.studentAllRates[length];
                    }
                }
            });
        });
        setTotalPaid(total);
    };

    const copyNewStudentFormUrlToClipboard = () => {
        let schoolName = ''
        switch(family.school.toLowerCase()) {
            default:
                schoolName = 'app'
                break;
            case 'mma':
                schoolName = 'mountainside'
                break;
            case 'lsma':
                schoolName = 'lakeside'
                break;
            case 'tma':
                schoolName = 'treeside'
                break;
            case 'mor':
                schoolName = 'morningside'
                break;
            case 'psma':
                schoolName = 'parkside'
        }
        navigator.clipboard.writeText(`https://${schoolName}.atharo.app/new-student/${family.familyId}`)
        .then(() => {
            alert('New Student Form URL copied to clipboard!')
        })
        .catch(err => console.log(err))
    }

    const findUniqueInstruments = (family) => {
        let instruments = [];
      
        family.students.forEach((student) => {
          student.instrumentList.forEach((instrument) => {
            instruments.push(instrument.name);
          });
        });
      
        // Convert the array to a Set to remove duplicates
        const uniqueInstrumentsSet = new Set(instruments);
      
        // Convert the Set back to an array
        const uniqueInstrumentsArray = [...uniqueInstrumentsSet];
      
        return uniqueInstrumentsArray;
      };

    const returnInfo = (label) => {
        if(label === 'Lessons / Month') {
            return lpm
        }
        if(label === 'Lessons Received') {
            return totalLessons
        }
        if(label === 'Paid') {
            return totalPaid
        }
    }

    const findFirstLesson = async () => {
        for(let i = 0; i < invoices.length; i++) {
            if(invoices[i].lessonsToBeBilled.length > 0) {
                let month = invoices[i].monthYear.split('/')[0]
                let year = invoices[i].monthYear.split('/')[1]
                let firstLessonDate = invoices[i].lessonsToBeBilled[0].date
                let parsedDate = parse(`${month} ${firstLessonDate} ${year}`, 'MMMM dd yyyy', new Date())
                setFirstLesson(format(parsedDate, 'MM/dd/yyyy'))
                break;
            }
        }
    }

    const editFamily = (e, input) => {
        setFamily({...family, [input]: e.target.value})
    }

    const toggleSwitch = (value, input) => {
        setFamily({...family, [input]: !value})
    }

    const makeANewWaveClient = async (theNewStudent) => {
        console.log('trying to make a new client')
        let businessId;
        let stateCode;
        //if(theNewStudent.familyStatus === "Active") {
        if (theNewStudent.school === "MMA") {
          businessId =
            "QnVzaW5lc3M6ZDVlMTRiODMtZDM1OC00MzVlLWI3ZWQtMzU2ZjAzNDAzYzBh";
          stateCode = "US-CO";
        } else if (theNewStudent.school === "LSMA") {
          businessId =
            "QnVzaW5lc3M6NGYxNWJhZGItYTc4Zi00ZjIxLWE2MDEtYmY0YjA2ZDVlNzk2";
          stateCode = "US-MN";
        } else if (theNewStudent.school === "TMA") {
          businessId =
            "QnVzaW5lc3M6OGMyMGUyN2YtZTQ2MC00ZGI2LWI1M2ItNGNhNzMxYTMyNDky";
          stateCode = "US-MI";
        } else if (theNewStudent.school === "MOR") {
          businessId =
            "QnVzaW5lc3M6MjgxYzUwZmQtMjg0Yi00MzMyLTk5NjEtN2Y3MjNkMDRkZmQw";
          stateCode = "US-OR";
        } else if (theNewStudent.school === "PSMA") {
          businessId = "QnVzaW5lc3M6YmY0MjEzYmYtYjEwYi00NmNhLTkyZTAtNjBiNTdmNDNlYzY5";
          stateCode = "US-WA";
        } else {
          alert("Please choose a school!");
          return;
        }
        //}
    
        let zipCodeString;
        if (theNewStudent.address.zipcode) {
          theNewStudent.address.zipcode.toString() === "0"
            ? (zipCodeString = "")
            : (zipCodeString = theNewStudent.address.zipcode.toString());
        } else {
          theNewStudent.address.zipcode = "0";
        }
    
        let createCustomerVariables = {
          input: {
            businessId: businessId,
            name: theNewStudent.familyName,
            firstName: theNewStudent.primaryParentName,
            lastName: theNewStudent.familyName,
            email: theNewStudent.primaryEmail,
            address: {
              addressLine1: theNewStudent.address.addressLine1,
              addressLine2: theNewStudent.address.addressLine2,
              city: theNewStudent.address.city,
              postalCode: zipCodeString,
              provinceCode: stateCode,
              countryCode: "US",
            },
            currency: "USD",
          },
        };
    
        return createCustomer({ variables: createCustomerVariables })
          .then((res) => {
            return res.data.customerCreate.customer.id;
          })
          .catch((err) => {
            // setError({
            //   message: err.networkError.result.errors,
            //   status: err.networkError.result.errors,
            // });
            console.log(err.networkError.result.errors);
            return;
          });
      };

    const changeFamilyStatus = async (e) => {
        let newCustomerId = (e.target.value === 'Active' && family.waveCustomerId === '' ? await makeANewWaveClient(family) : family.waveCustomerId)
        console.log(newCustomerId)
        let message = `The *${family.familyName} Family* has been changed from *${family.familyStatus}* to *${e.target.value}*`
        axios.post(`${baseUrl}/atharo-slack/${family.school.toLowerCase()}`, {message: message}, getRequestHeaders())
        setFamily({...family, familyStatus: e.target.value, waveCustomerId: newCustomerId})
    }


    return (
        <div className="student-modal-2023__left-gutter">
            <div className='student-modal-2023__left-gutter__content'>
                <div className='student-modal-2023__left-gutter__family-name'>{family.familyName}</div>
                <div className='student-modal-2023__left-gutter__details'>
                    <select className='student-modal-2023__left-gutter__school-select' onChange={(e) => editFamily(e, 'school')} value={family.school}>
                        {schoolOptions.map(school => <option value={school.value}>{school.name}</option>)}
                    </select>
                    <select className='student-modal-2023__left-gutter__status-select' onChange={(e) => changeFamilyStatus(e)} style={statusStyles(family.familyStatus)} value={family.familyStatus} >
                        {statusOptions.map(status => <option value={status.value}>{status.label}</option>)}
                    </select>
                    <div className='student-modal-2023__left-gutter__switch__wrapper' onClick={() => toggleSwitch(family.moreAttention, 'moreAttention')}>
                        <ShortToggle value={family.moreAttention} />
                        <div className='student-modal-2023__left-gutter__switch__label'>Needs Attention</div>
                    </div>
                    <div className='student-modal-2023__left-gutter__switch__wrapper' onClick={() => toggleSwitch(family.autoPay, 'autoPay')}>
                        <ShortToggle value={family.autoPay} />
                        <div className='student-modal-2023__left-gutter__switch__label'>Auto-Pay</div>
                    </div>
                    <div className='student-modal-2023__left-gutter__invoice-info__wrapper'>
                        {invoiceInfo.map(info => (
                                <div className='student-modal-2023__left-gutter__invoice-info__item'>
                                    {info.icon}
                                    <div className='student-modal-2023__left-gutter__invoice-info__item__label-value'>{info.label === 'Paid' && '$'}{returnInfo(info.label)} {info.label}</div>
                                </div>
                        ))}
                    </div>
                    <div className='student-modal-2023__left-gutter__invoice-info__instruments-wrapper'>
                        {findUniqueInstruments(family).map(instrument => <div className='student-modal-2023__left-gutter__invoice-info__instruments-wrapper__instrument-chip'>{instrument}</div>)}
                    </div>
                    <div className='student-modal-2023__left-gutter__invoice-info__bottom-section'>
                        <div className='family-info-gutter__new-student-form-btn' onClick={() => copyNewStudentFormUrlToClipboard()}>
                            <div className='family-info-gutter__new-student-form-btn__text'>New Student Form</div>
                            <MdContentCopy />
                        </div>
                        <div className='student-modal-2023__left-gutter__invoice-info__form-submitted-date'>Form Submitted: {format(new Date(family.onboardDate), 'MM/dd/yyyy')}</div>
                        <div className='student-modal-2023__left-gutter__invoice-info__form-submitted-date'>First Lesson: {firstLesson}</div>
                    </div>
                </div>
            </div>
            <div className='student-modal-2023__left-gutter__delete-family__wrapper'>
                <div className='student-modal-2023__left-gutter__delete-family' onClick={() => deleteFamilyFromState(family.familyId)}>
                    <MdDeleteOutline className='student-modal-2023__left-gutter__delete-family__icon' size={18} color='#DC2626' />
                    <div className='student-modal-2023__left-gutter__delete-family__text'>Delete Family</div>
                </div>
            </div>
        </div>
    );
}
export default LeftGutterStudentModal2023;